import { Component, Input } from '@angular/core';
import FileSaver from 'file-saver';
import { CPMemberService } from 'src/app/cp-member/services/CPMember.service';
import { AlertService } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-pdf-block',
  templateUrl: './pdf-block.component.html',
  styleUrls: ['./pdf-block.component.scss'],
})
export class PdfBlockComponent {
  @Input() document ;
  isDocumentLoading=false;
  constructor(private cpMemberService: CPMemberService,
    private alertService: AlertService
  ){

  }

  ngOnInit(){
// console.log("document....", this.document);
  }

  downloadDocument(){
    this.isDocumentLoading = true;
    // console.log("The documentDetailId is "+ this.document.DocumentDetailId);
    this.cpMemberService.downloadUploadedDocuments(this.document.DocumentDetailId)
        .then(result => {
          const blob = this.dataURItoBlob(result.FileBytes);
          FileSaver.saveAs(blob, this.document.FileName);
          this.isDocumentLoading = false;
        })
        .catch(error => {
          this.alertService.error("Error occured!");
          this.isDocumentLoading = false;
        });
  }

  dataURItoBlob(base64str) {
    const dataURI = 'data:application/pdf;base64, ' + encodeURI(base64str);
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    const ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    const blob = new Blob([ab], { type: mimeString });
    return blob;
  }

}
